/**
 * Lightweight dev-only logger. Production builds (NODE_ENV=production)
 * suppress all log/info/debug output; warnings and errors are kept because
 * they may be diagnostically relevant.
 *
 *   import { logger } from '@/utils/logger';
 *   logger.debug('foo');     // silent in prod
 *   logger.warn('careful');  // always visible
 *   logger.error('bad');     // always visible (later: forward to Sentry/LogRocket)
 */
const isProd = process.env.NODE_ENV === 'production';

export const logger = {
  debug: (...args) => { if (!isProd) console.log(...args); },
  info: (...args) => { if (!isProd) console.info(...args); },
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};
